import React, { useRef } from "react";
import {
  Chart,
  Series,
  ArgumentAxis,
  ValueAxis,
  Legend,
  Tooltip,
  Label,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const BreakdownBySector = ({ data, palette }) => {
  const chartRef = useRef(null);

  const customizeTooltip = (arg) => {
    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${arg.argumentText}</div>
          <div><span style="font-weight: 600;">${arg.seriesName}</span>: ${arg.valueText} €</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard
      title="Breakdown by Sector"
      chartRef={chartRef}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={data}
          id="sectorChart"
          ref={chartRef}
          palette={palette}
          rotated={false}
        >
          <Series
            valueField="SumEclDeparture"
            argumentField="SectorLib"
            name="Departure"
            type="bar"
          />
          <Series
            valueField="SumEclArrival"
            argumentField="SectorLib"
            name="Arrival"
            type="bar"
          />
          <ArgumentAxis>
            <Label
              wordWrap="normal"
              textOverflow="ellipsis"
              overlappingBehavior="rotate"
              rotationAngle={45}
            />
          </ArgumentAxis>
          <ValueAxis />
          <Legend
            visible={true}
            horizontalAlignment="center"
            verticalAlignment="bottom"
          />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
            format="fixedPoint"
            precision={2}
          />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default BreakdownBySector;
